import { Component, OnDestroy, OnInit } from '@angular/core';
import { TravelService } from 'src/app/service/travel.service';
import { CreateApplicationResponse } from 'src/app/shared/insurance.model';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss']
})
export class SuccessPageComponent implements OnInit {
  private id: number;

  createApplicationResponse: CreateApplicationResponse;

  constructor(private travelService: TravelService, private route: ActivatedRoute) {

    route.params.subscribe(params => {
      this.id = params['id'];

    });

   }

   async ngOnInit() {

   }

  downloadPolicy() {
    this.travelService.getPolicyPrintForm(this.id).subscribe(
      data => {
        let file = data as Blob;
        const downloadURL = URL.createObjectURL(file);
        window.open(downloadURL, '_blank');
      }
    );
  }
}

